import { Component, input, output } from '@angular/core';
import { LucideAngularModule, X } from 'lucide-angular';

@Component({
  selector: 'app-dialog-header',
  imports: [LucideAngularModule],
  templateUrl: './dialog-header.component.html',
  styleUrl: './dialog-header.component.scss',
})
export class DialogHeaderComponent {
  protected readonly X = X;
  protected xIconClicked = false;
  readonly title = input('');
  readonly showBottomBorder = input(false);
  readonly closeDialog = output<void>();

  protected closeClick() {
    this.closeDialog.emit();
  }

  protected handleXIconClick(): void {
    this.xIconClicked = true;
  }

  protected handleXIconRelease(): void {
    if (this.xIconClicked) {
      this.xIconClicked = false;
    }
  }
}
